import type { Theme } from "@mui/material";
import {
  SIDE_DRAWER_BACKDROP_Z_INDEX,
  SIDE_DRAWER_MAX_WIDTH,
  SIDE_DRAWER_Z_INDEX,
} from "@constants/layout.style.ts";

export const getSideDrawerStyles = (theme: Theme) => ({
  drawer: {
    zIndex: SIDE_DRAWER_Z_INDEX,
    position: "fixed",
    right: 0,
    top: 0,
    bottom: 0,
    height: "100vh",
    width: "100%",
    maxWidth: SIDE_DRAWER_MAX_WIDTH,
    backgroundColor: theme.palette.background?.default ?? "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    overflowY: "hidden",
  },
  backdrop: {
    zIndex: SIDE_DRAWER_BACKDROP_Z_INDEX,
  },
  headerText: {
    color: theme.palette.text.primary,
  },
  descriptionText: {
    color: theme.palette.text.primary,
  },
  idText: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
  },
  footerBorder: {
    borderTop: `1px solid ${theme.palette.strokeColor.secondary}`,
  },
  inputRoot: {
    borderColor: theme.palette.strokeColor?.primary ?? "#BBC1C5",
    color: theme.palette.text.primary,
  },
  inputBaseRoot: {
    borderRadius: "8px",
    borderColor: theme.palette.strokeColor?.primary ?? "#BBC1C5",
    padding: "12px",
    fontSize: theme.typography?.body1?.fontSize ?? "14px",
    color: theme.palette.text.primary,
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: "12px",
    fontWeight: "500",
  },
});
